<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_ii"></a><a id="page_iii">DIE WEHRMACHT IM KAMPF</a></p><a id="page_iii">
<h1 class="title">OPERATION <em class="italic">CRUSADER</em>: TANK WARFARE IN THE DESERT, TOBRUK 1941</h1>
<p class="author">HERMANN BÜSCHLEB</p>
<p class="author1"> TRANSLATED BY DAVID DORONDO SERIES EDITOR: MATTHIAS STROHN</p>
<p class="pub"><img alt="" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?67e41bde